import React from 'react';

// Investment Focus - Sectors. 56x56 gradient-bordered tile (the frame is part of
// the artwork), glyph exactly as Figma drew it. Gradient ids are per-instance
// (useId) so several icons on one page don't share ids and break.
const GRADIENT_STOPS = (
  <>
    <stop stopColor="#7458F6" />
    <stop offset="1" stopColor="#84AEF8" />
  </>
);

const SectorsIcon = ({ size = 56 }) => {
  const uid = React.useId();
  const g = (n) => `sectors_${uid}_${n}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="0.5" y="0.5" width="55" height="55" rx="11.5" stroke={`url(#${g(0)})`} />
      <circle cx="28" cy="28" r="11" stroke={`url(#${g(1)})`} strokeWidth="2" />
      <path
        d="M28 28.0001V17"
        stroke={`url(#${g(2)})`}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28 28L38 32.5"
        stroke={`url(#${g(3)})`}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient id={g(0)} x1="28" y1="0" x2="28" y2="56" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient id={g(1)} x1="28" y1="16" x2="28" y2="40" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient id={g(2)} x1="28.5" y1="16" x2="28.5" y2="28" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient id={g(3)} x1="33" y1="28" x2="33" y2="33" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
      </defs>
    </svg>
  );
};

export default SectorsIcon;
